export default __webpack_public_path__ + "static/media/Bhaisahab-Ye-Kis-Line-Mei-Aa-Gaye-Aap-meme-template-of-welcome-movie.19216005.jpg";